// extracted by mini-css-extract-plugin
export default {"user_config":"iInLZ8gKp-L1kjg4QbzpyA==","menuItemLink":"Ub3Ivc-U4SpKJI1PmOyzAQ==","menuItem":"YEBUap7WyxA1fNSG7Acphg=="};